"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var baseField_1 = require("./baseField");
var IntField = /** @class */ (function (_super) {
    __extends(IntField, _super);
    function IntField(key, label, isRequired, requiredValidationMessage, initialValue) {
        var _this = _super.call(this, _1.FieldType.Int, key, label, isRequired, 10, requiredValidationMessage) || this;
        _this.key = key;
        if (initialValue) {
            _this.setValue(initialValue);
        }
        return _this;
    }
    Object.defineProperty(IntField.prototype, "errorMessage", {
        get: function () {
            var baseErrorMessage = _super.prototype.getErrorMessage.call(this);
            if (baseErrorMessage) {
                return baseErrorMessage;
            }
            if (this.value && !this.isValidNumber() && this.isDirty) {
                return 'Number is invalid';
            }
            return baseErrorMessage;
        },
        enumerable: false,
        configurable: true
    });
    IntField.prototype.isValidNumber = function () {
        var regex = /^[-+]?\d+$/;
        return regex.test(this.value.toString());
    };
    IntField.prototype.isValid = function () {
        var isValid = true;
        if (!this.checkRequiredStatus()) {
            isValid = false;
        }
        if (this.stringValue && !this.isValidNumber()) {
            isValid = false;
        }
        this.setIsValid(isValid);
        return isValid;
    };
    IntField.prototype.setValue = function (newValue) {
        if (newValue === undefined || newValue === null) {
            this.setStringValue('');
        }
        else {
            this.setStringValue(newValue.toString());
        }
    };
    Object.defineProperty(IntField.prototype, "value", {
        get: function () {
            if (!this.stringValue) {
                return null;
            }
            return parseInt(this.stringValue, 10);
        },
        enumerable: false,
        configurable: true
    });
    return IntField;
}(baseField_1.default));
exports.default = IntField;
